import { render, staticRenderFns } from "./SaleAgentDetailsView.vue?vue&type=template&id=1ec33604&scoped=true"
import script from "./SaleAgentDetailsView.vue?vue&type=script&lang=js"
export * from "./SaleAgentDetailsView.vue?vue&type=script&lang=js"
import style0 from "./SaleAgentDetailsView.vue?vue&type=style&index=0&id=1ec33604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec33604",
  null
  
)

export default component.exports